"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const complex_data_1 = require("complex-data");
const complex_utils_1 = require("complex-utils");
const require_1 = __importDefault(require("../../require"));
const getTypeList = ['get', 'delete'];
function appendProp(requireData, propList, args) {
    if (propList && propList.length > 0 && args && args.length > 0) {
        for (let i = 0; i < propList.length; i++) {
            const prop = propList[i];
            const data = args[i];
            if (data !== undefined) {
                if (prop !== 'url') {
                    requireData[prop] = data;
                }
                else {
                    requireData.url += data;
                }
            }
        }
    }
}
class ApiData extends complex_data_1.Data {
    constructor(initOption) {
        super();
        this.name = initOption.name;
        this.url = initOption.url;
        this.token = initOption.token;
        this.urlConfig = initOption.urlConfig || {
            pre: '',
            service: ''
        };
        this.method = initOption.method || 'get';
        this.format = initOption.format;
        if (initOption.data) {
            this.data = initOption.data.map(dataStr => {
                if (dataStr === 'inherit') {
                    dataStr = getTypeList.indexOf(this.method) > -1 ? 'params' : 'data';
                }
                return dataStr;
            });
        }
        else {
            this.data = [];
        }
    }
    require(...args) {
        const method = this.method;
        const url = ApiData.formatApi(this.url, this.urlConfig);
        const requireOption = {
            url: url,
            token: this.token,
            $format: this.format
        };
        appendProp(requireOption, this.data, args);
        const promise = require_1.default[method](requireOption);
        return promise;
    }
}
ApiData.formatApi = function (url, urlConfig) {
    if (urlConfig) {
        if (!(0, complex_utils_1.isCompleteUrl)(url)) {
            if (urlConfig.pre && (0, complex_utils_1.isCompleteUrl)(urlConfig.pre)) {
                return urlConfig.pre + url;
            }
            if (urlConfig.service) {
                return urlConfig.service + url;
            }
        }
    }
    return url;
};
exports.default = ApiData;
